{
  "sdk-download-android": "Unduh untuk Android",
  "sdk-connect": "Terhubung",
  "sdk-download-ios": "Unduh untuk iOS",
  "sdk-install": "Instal",
  "sdk-modal-instruct-1": "1. Buka aplikasi Binance",
  "sdk-modal-instruct-2": "2. Ketuk {{icon}} di Layar Beranda",
  "sdk-modal-title": "Hubungkan dengan Binance",
  "sdk-no-app": "Belum punya aplikasi Binance?"
}